import jQuery from 'jquery';

;(function($){

//========================================================
//
// ■XJStorageLoaderクラス定義
//
//========================================================
$(function(){
  const $this = $('#irNewsList');
  if(!$this.length) return;

  var site_domain="/";
  var irlist_path="ir/list/";
  const len = $this.data('len') ? $this.data('len') : 100;
  const className = $this.data('class') ? $this.data('class') : 'c-newsList';

  $this.prepend('<ul class="'+className+'" data-id="xj-mainlist"></ul>');

  /*========================================================
    コンストラクタAS80522
  ========================================================*/
  var XjStorageLoaderNews = function(s)
  {
    var defaults =
    {
      domain:'https://www.xj-storage.jp',
      company:'AS80522',
      pdf:'1',
      len:'5',
      documents_all:'',
      documents_Disclosure:'0,5,6,8,9,13,15,24,25,28',
      documents_Fresults:'1,2,3,4,16,17,18,19,20,21',
      documents_Sreport:'99,105,106,107,108,1030,1040,1080,1090,1100,1120,1130,1135,1136,1140,1150,1160,1170,1180,1190,1200,1210,1220,1230,1235,1236,1240,1250,1260,1270,1280,1290,1300,1310,1320,1350,1360',
      documents_Ir:'34,90,91,92,93,95,96,97,98,101,102,103,104,110,111,112,113,114,115,116,117,118,119,120',
      documents_Info:'14,200'
    };

    this.settings = $.extend ( defaults, s ) ;
    this.fdate;
    this.pdate;
    this.documents;
    this.select_latest = '';
    this.select_oldest = '';

    this.ary_doc_no ;
    this.ary_doc_Disclosure ;
    this.ary_doc_Fresults ;
    this.ary_doc_Sreport ;
    this.ary_doc_Ir ;
    this.ary_doc_Info ;


    XjStorageLoaderNews.prototype.init.call(this);
  };

  /*========================================================
    初期設定
  ========================================================*/
  XjStorageLoaderNews.prototype.init = function()
  {


    $.ajaxSetup({scriptCharset:'utf-8'});

    this.ary_doc_Disclosure  = this.settings.documents_Disclosure.split ( "," )
    this.ary_doc_Fresults  = this.settings.documents_Fresults.split ( "," ) ;
    this.ary_doc_Sreport  = this.settings.documents_Sreport.split ( "," ) ;
    this.ary_doc_Ir  = this.settings.documents_Ir.split ( "," ) ;
    this.ary_doc_Info  = this.settings.documents_Info.split ( "," ) ;


      this.settings.documents_all =
          this.settings.documents_Disclosure + ',' +
          this.settings.documents_Fresults + ',' +
          this.settings.documents_Sreport + ',' +
          this.settings.documents_Ir + ',' +
          this.settings.documents_Info ;

    //初期読み込み対象指定
    this.documents = this.settings.documents_all;
    this.ary_doc_no = this.documents.split ( "," ) ;

    if(false){
      this.setMaxMinYear ( this.documents ) ;  //記事年範囲取得
    } else if(true){
      var params = [];
      var param = location.search.substring(1).split('&');
      for(var i = 0; i < param.length; i++) {
          params[i] = param[i].split('=');
      }

      var target = 'pattern';
      var value;
      for(var i = 0; i < params.length; i++) {
          if(params[i][0] == target) {
              value = params[i][1];
              break;
          }
      }
      var now = new Date();
      var year = now.getFullYear();
      if(value == null){
        value = year;
        this.setDuration (value + '1231', '20150101', this.settings.len);
      } else{
        this.setDuration (value + '1231', value + '0101', this.settings.len);
      }
    }
  };

  /*========================================================
    最新の年と最古の年の設定
  ========================================================*/
  XjStorageLoaderNews.prototype.setMaxMinYear = function(code)
  {
    var self = this;
    var xjurl = '';

    //URL生成
    xjurl += self.settings.domain + '/public-list/GetList.aspx?company=';
    xjurl += self.settings.company;
    xjurl += '&len=10000';
    //xjurl += '&doctype=' + this.documents;
    xjurl += '&output=json&callback=?';

    $.ajax (
    {
      url: xjurl,
      dataType: 'json',

      success : function ( data )
      {
        if ( undefined == data.items )
        {
          return ;
        }

        $.each ( data.items, function ( i, item )
        {

          // 目的の文書番号でなかったら
          if ( -1 == self.ary_doc_no.indexOf ( item.disclosureCode ) )
          {
            return true;
          }

          var date = item.publishDate.split(' ')[0].split('/');
          var entry_year = date[0];

          //最新の年月期と最古の年月期を取得
          if ( self.select_latest === '' )
          {
            self.select_latest = entry_year ;
          }

          if ( self.select_oldest === '' || self.select_latest >= entry_year )
          {
            self.select_oldest = entry_year ;
          }
        });

        self.active_select = self.select_latest ;
      },
      complete : function()
      {
        self.show ( 5 ) ;
      }
    }
    );
  }

  /*========================================================
    絞込み期間更新
  ========================================================*/
  XjStorageLoaderNews.prototype.setDuration = function ( f, p ,l )
  {
    this.fdate = f;
    this.pdate = p;
    this.len = l;
    this.show( l );
  }

  /*========================================================
    表示処理
  ========================================================*/
  XjStorageLoaderNews.prototype.show = function ( l )
  {
    var self = this;
    var is_first = true;

    var url =  this.settings.domain + '/public-list/GetList.aspx?company=';

    url += this.settings.company;

    // 日付範囲指定
    if ( this.fdate && this.fdate.length > 0 )
    {
      url+= '&fdate=' + this.fdate;
    }

    if ( this.pdate && this.pdate.length > 0 )
    {
      url+= '&pdate=' + this.pdate;
    }

    // 取得個数指定
    if ( !( this.pdate && this.pdate.length > 0 ) &&
        !( this.fdate && this.fdate.length > 0 ) )
    {
      url+= '&len=' + self.settings.len;
    }
    else
    {
      url+= '&len=' + l;
    }

    // タイプ指定
    if ( this.documents && this.documents.length > 0 )
    {
      url+= '&doctype=' + this.documents;
    }

    //url+= '&filetype=PDF-GENERAL';
    url+= '&output=json&callback=?';

    $.getJSON ( url, function ( data )
    {
      $this.find('[data-id="xj-mainlist"]').empty ( ) ;

      var cont = '' ;

      if ( data.items )
      {

        $.each ( data.items, function ( i, item )
        {
          var entrytype = '';
          var url = '';
          var size = '';
          var page = '';

          if ( item.files )
          {
            $.each ( item.files, function ( j, file )
            {
              if ( file.type == 'PDF-GENERAL')
              {
                url = file.url ;
                size = parseInt ( file.size ) ;
                page = file.page ;
              }
            });
          }

          // サイズ設定
          if ( size > 0 )
          {

            if ( size > 1000000 )
            {
              size = parseInt ( size / 1000000 ) + 'M' ;
            }

            else if ( size > 1000 )
            {

              size = parseInt ( size / 1000 ) + 'K' ;
            }
          }
          else
          {
            size = '－' ;
          }

          // アイコンファイル設定
          var icon_class = '' ;
          var icon_alt = '' ;


          if ( -1 != self.ary_doc_Disclosure.indexOf ( item.disclosureCode ) )
          {
            icon_class = 'eventTableCat-1';
            icon_alt = '<span class="c-label bg_yellow cat">' + '適時開示' + '</span>';
          }
          else if ( -1 != self.ary_doc_Fresults.indexOf ( item.disclosureCode ) )
          {
            icon_class = 'eventTableCat-2';
            icon_alt = '<span class="c-label bg_orange cat">' + '決算短信' + '</span>';
          }
          else if ( -1 != self.ary_doc_Sreport.indexOf ( item.disclosureCode ) )
          {
            icon_class = 'eventTableCat-3';
            icon_alt = '<span class="c-label bg_green cat">' + '法定開示' + '</span>';
          }
          else if ( -1 != self.ary_doc_Ir.indexOf ( item.disclosureCode ) )
          {
            icon_class = 'eventTableCat-4';
            icon_alt = '<span class="c-label bg_purple cat">' + 'IR資料' + '</span>';
          }
          else if ( -1 != self.ary_doc_Info.indexOf ( item.disclosureCode ) )
          {
            icon_class = 'eventTableCat-5';
            icon_alt = '<span class="c-label bg_blue cat">' + 'お知らせ' + '</span>';
          }

          // 日付設定
          var date = item.publishDate.split(' ')[0].split('/');
          var dateStr = date[0] + '.' + date[1] + '.' + date[2] ;

          // 画面表示
          cont += '<li class="'+ icon_class +'"><dl>';
          cont += '<dt><span class="date">' + dateStr + '</span>'+ icon_alt + '</dt>';
          if ( url != '')
          {
            cont += '<dd><a href="' + url + '" target="_blank" class="link_pdf fade normal">';
          }
          if ( url != '' && size != '－' )
          {
            cont += ' <span class="icon">【PDF】</span>' ;
          }
          cont += '<span class="txt">' + item.title ;
          if ( url != '' && size != '－' )
          {
            cont += '　(' + size + 'B/' + page + 'P）' ;
          }
          if ( url != '' )
          {
            cont += '</span></a></dd></dl></li>' ;
          }
        });
      }
      else
      {
        cont += '<li class="notxt"><span>ただいま掲載すべき事項はございません。</span></li>' ;
      }

      $this.find('[data-id="xj-mainlist"]').html(cont);
    });
  }

  /*========================================================
    実行
  ========================================================*/
  var xj_storage_loader = new XjStorageLoaderNews({len:len});

});

}(jQuery));